import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSnackbarComponent } from './custom-snackbar/custom-snackbar.component';
import { MatIconModule } from '@angular/material/icon';
import { HidableContainerComponent } from './hidable-container/hidable-container.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TabsComponent } from './tabs/tabs.component';



@NgModule({
  declarations: [CustomSnackbarComponent, HidableContainerComponent, TabsComponent],
  exports: [
    HidableContainerComponent,
    TabsComponent
  ],
    imports: [
        CommonModule,
        MatIconModule,
        ReactiveFormsModule
    ]
})
export class SharedModule { }
